module.exports = __webpack_public_path__ + "static/media/profile_image.9994c3b5.jpg";